import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { ExportOrderEntriesComponent, ExportOrderEntriesToCsvService } from '@spartacus/cart/import-export/components';
import { ExportConfig, ImportExportConfig } from '@spartacus/cart/import-export/core';
import { ContextService } from '@spartacus/storefront';
import { BehaviorSubject, of, Subscription, switchMap } from 'rxjs';
import { CustomExportOrderEntriesToCsvService } from './export-order-entries-to-csv.service';

@Component({
  selector: 'cx-export-order-entries',
  templateUrl: './export-order-entries.component.html',
  styleUrl: 'export-order-entries.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomExportOrderEntriesComponent
  extends ExportOrderEntriesComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() InEnties$?: OrderEntry[];
  @Input() label: string = 'exportEntries.exportProductToCsv';
  @Input() btnClass: string = 'btn-primary';
  @Input() exportConfig?: ExportConfig = this.importExportConfig.cartImportExport?.export;
  @HostBinding('class') override styles = '';

  subscription = new Subscription();
  override entries$ = new BehaviorSubject<OrderEntry[] | undefined>(undefined);

  constructor(
    protected _exportEntriesService: ExportOrderEntriesToCsvService,
    protected _contextService: ContextService,
    private importExportConfig: ImportExportConfig,
    protected customExportEntriesService: CustomExportOrderEntriesToCsvService,
  ) {
    super(_exportEntriesService, _contextService);
  }

  ngOnInit(): void {
    this.checkEntries();
  }

  ngOnChanges(): void {
    this.checkEntries();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkEntries() {
    if (this.InEnties$) {
      const entries = this.InEnties$?.map(entry => {
        const totalPrice = (entry.product?.yourPrice?.value ?? 0) * (entry.quantity ?? 0);

        return {
          ...entry,
          totalPrice: {
            value: totalPrice,
            formattedValue: totalPrice.toString(),
          },
        };
      });

      this.entries$.next(entries);
    } else {
      this.subscription.add(
        this.orderEntriesContext$
          .pipe(switchMap(orderEntriesContext => orderEntriesContext?.getEntries?.() ?? of(undefined)))
          .subscribe(entries => {
            this.entries$.next(entries);
          }),
      );
    }
  }

  override exportCsv(entries: OrderEntry[]): void {
    const config = this.exportConfig;
    this.customExportEntriesService.downloadCsv(entries, config!);
  }
}
